import { BookMode, BookType, BookWithProgress, CEFRLevels, GESELevels } from './Book.types'

export const sortBooksByCEFR = (booksWithProgress: BookWithProgress[]): BookWithProgress[] => {
  const booksToReturn: BookWithProgress[] = []
  const booksWithCEFR = booksWithProgress.filter((b) => !!b.book.cefrLevel)
  const booksWithoutCEFR = booksWithProgress.filter((b) => !b.book.cefrLevel)

  booksToReturn.push(...booksWithCEFR.sort((a, b) => a.book.cefrLevel!.localeCompare(b.book.cefrLevel!)))
  booksToReturn.push(...booksWithoutCEFR)

  return booksToReturn
}

export const getBookModeFromBookType = (bookType: BookType) => {
  switch (bookType) {
    case BookType.Listening:
      return BookMode.LISTEN
    case BookType.Reading:
      return BookMode.READ
    default:
      return BookMode.READ
  }
}

export const geseLevelToNumericValue = (geseLvl: GESELevels): number => {
  switch (geseLvl) {
    case GESELevels.ONE:
      return 1
    case GESELevels.TWO:
      return 2
    case GESELevels.THREE:
      return 3
    case GESELevels.FOUR:
      return 4
    case GESELevels.FIVE:
      return 5
    case GESELevels.SIX:
      return 6
    case GESELevels.SEVEN:
      return 7
    case GESELevels.EIGHT:
      return 8
    case GESELevels.NINE:
      return 9
    case GESELevels.TEN:
      return 10
    case GESELevels.ELEVEN:
      return 11
    case GESELevels.TWELVE:
      return 12
  }
}

export const cefrLevelToNumbericValue = (cefrLvl: CEFRLevels) => {
  switch (cefrLvl) {
    case CEFRLevels.PreA1:
      return 0
    case CEFRLevels.A11:
      return 1
    case CEFRLevels.A12:
      return 2
    case CEFRLevels.A13:
      return 3
    case CEFRLevels.A21:
      return 4
    case CEFRLevels.A22:
      return 5
    case CEFRLevels.A23:
      return 6
    case CEFRLevels.B11:
      return 7
    case CEFRLevels.B12:
      return 8
    case CEFRLevels.B13:
      return 9
    case CEFRLevels.B21:
      return 10
    case CEFRLevels.B22:
      return 11
    case CEFRLevels.B23:
      return 12
    case CEFRLevels.C1plus:
      return 13
  }
}
